import { render, staticRenderFns } from "./CommunicationRow.vue?vue&type=template&id=fee96c42&"
import script from "./CommunicationRow.vue?vue&type=script&lang=js&"
export * from "./CommunicationRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports